


































































































































































































































































import { Component } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import { BreadcrumbData } from '@/componentsV2/molecules/Breadcrumbs/Breadcrumbs.vue';
import ImageSpecialCoinPreview from '@/components/organisms/Offers/ImageSpecialCoinPreview.vue';
import DiscountOffer from '@/components/molecules/DiscountOffer/DiscountOffer.vue';
import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import ReportItem from '@/components/atoms/ReportItem/ReportItem.vue';
import SpecialCoinIcon from '@/components/icons/SpecialCoin.vue';
import CustomersIcon from '@/components/icons/Customers.vue';
import CalendarIcon from '@/components/icons/Calendar.vue';
import PlusCircleIcon from '@/components/icons/PlusCircle.vue';
import ConvertIcon from '@/components/icons/Convert.vue';
import ShareIcon from '@/components/icons/Share.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import ShareOfferTooltip from '@/components/ShareOfferTooltip/ShareOfferTooltip.vue';
import Arrow from '@/components/icons/Arrow.vue';
import CircleBlock from '@/components/icons/CircleBlock.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import CircleCancel from '@/components/icons/CircleCancel.vue';
import CameraIcon from '@/components/icons/Camera.vue';
import OfferImageUpload from '@/componentsV2/molecules/Inputs/OfferImageUpload.vue';
import Loading from '@/components/icons/Loading.vue';
import LocationsAndWebsiteCard from '@/componentsV2/organisms/LocationsAndWebsiteCard/LocationsAndWebsiteCard.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import SectionData from '@/componentsV2/organisms/SectionData/SectionData.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';

import {
  CustomSelectOption,
  CustomSelectGroup,
  CustomSelectModel
} from '@/components/CustomSelect/CustomSelectModel';

import {
  EOfferStatusEnum,
  IOfferMethod,
  EOfferRulesName,
  SpecialOfferTypeEnum,
  getRenewedValue,
  getRedeemableString
} from '@/models/offer';

import SpecialCoinOffersService from '@/api/SpecialCoinOffersService';
import OffersService from '@/api/OffersService';
import basePagination from '@/components/BasePagination/BasePagination.vue';
import { HeaderList, List } from '@/components/Table/TableModel';

import flagKeys from '@/constants/flagKeys';

import eventBus from '@/utils/eventBus';
import isMobile from '@/utils/mobile-check';
import PaginationHelper from '@/utils/PaginationHelper';
import DateUtils from '@/utils/DateUtils';
import { renderTextWithLinks } from '@/utils/renderTextWithLinks';
import { getUrlHostname } from '@/utils/getUrlHostname';
import ClockIcon from '@/components/icons/Clock.vue';
import MemberList from '@/components/organisms/Offers/DataPresentation/MemberList.vue';
import { IPaginationTableHeader } from '@/utils/PaginationUtils';
import EmptyImageIcon from '@/components/icons/EmptyImage.vue';
import PlusIcon from '@/components/icons/Plus.vue';
import InStoreIcon from '@/components/icons/InStore.vue';
import OfferTypeTag from '@/components/molecules/OfferTypeTag/OfferTypeTag.vue';

export const SpecialOfferTags = [
  {
    label: 'Storewide deal',
    type: 'storewide-deal',
    specialType: 'Storewide'
  },
  {
    label: 'Specific product / service',
    type: 'specific-product',
    specialType: 'ProductAndService'
  },
  { label: 'Birthday offer', type: 'birthday-offer', specialType: 'Birthday' }
];

@Component({
  components: {
    Page,
    ImageSpecialCoinPreview,
    DiscountOffer,
    FilterTag,
    ReportItem,
    SpecialCoinIcon,
    CustomersIcon,
    CalendarIcon,
    PlusCircleIcon,
    ConvertIcon,
    FilledButton,
    ShareIcon,
    ShareOfferTooltip,
    Arrow,
    CircleBlock,
    CoinsIcon,
    CircleCancel,
    OfferImageUpload,
    CameraIcon,
    Loading,
    LocationsAndWebsiteCard,
    Typography,
    ClockIcon,
    SectionData,
    CustomSelect,
    TextField,
    MemberList,
    EmptyImageIcon,
    PlusIcon,
    InStoreIcon,
    OfferTypeTag
  }
})
export default class OfferDetail extends basePagination {
  offerData: any = false;
  helper: PaginationHelper = new PaginationHelper();
  activeTooltip = false;
  uploadImageLoading = false;

  formData = {
    image: {
      imageUrl: ''
    }
  };

  service = new SpecialCoinOffersService();
  serviceOffer = new OffersService();

  headers: Record<string, IPaginationTableHeader> = {
    member: {
      label: 'Member'
    },
    rendemptionDate: {
      label: 'Rendemption date',
      sortable: true
    },
    location: {
      label: 'Location'
    },
    status: {
      label: 'Status',
      sortable: true
    }
  };

  membersData: List = new List([], []);
  listEmpty: boolean = true;
  endpointPath = '';
  sortField = 'redeemedDate';
  sortOrder = 'DESC';

  get locationsAmount() {
    return (this.offerData.locations || []).length;
  }

  get status() {
    return this.offerData.status;
  }

  get redeemableLocations() {
    if (this.offerData.method === IOfferMethod.ONLINE) return [];

    return this.offerData.locations || [];
  }

  get redeemableWebsite() {
    if (
      [IOfferMethod.ONLINE, IOfferMethod.BOTH].includes(
        this.offerData.method
      ) &&
      this.business.website
    ) {
      return this.offerData.link || getUrlHostname(this.business.website);
    }

    return '';
  }

  get shouldShowClickedToUseCard() {
    return this.offerData.hasOwnProperty('clickExternalRedeemCounter');
  }

  get tPrefix() {
    return `offers`;
  }

  get tPrefixDetail() {
    return `${this.tPrefix}.detail`;
  }

  get tPrefixForm() {
    return `${this.tPrefix}.form`;
  }

  get isMobileDevice() {
    return isMobile();
  }

  get breadcrumbs() {
    const breadcrumbList: BreadcrumbData[] = [
      {
        label: this.$t(`${this.tPrefix}.breadcrumbs`) as string,
        path: '/special-coins-offers'
      },
      {
        label: this.$t(`${this.tPrefixDetail}.breadcrumbs`) as string
      }
    ];

    return breadcrumbList;
  }

  get date() {
    return `Created on ${DateUtils.formattedDate({
      date: this.offerData.createdAt,
      applyTimezone: true
    })}`;
  }

  get shouldArchive() {
    return this.offerData.status === 'active';
  }

  get opened() {
    return this.offerData.viewsCounter;
  }

  get saved() {
    return this.getRelationByMaxRedeemed(this.offerData, 'savedCounter');
  }

  get redeemed() {
    return this.getRelationByMaxRedeemed(this.offerData, 'redeemsCounter');
  }

  get getDirectionsCount() {
    return this.offerData.getDirectionsCounter || 0;
  }

  get shared() {
    return this.offerData.sharedCounter;
  }

  get nonMemberReached() {
    return this.offerData.nonMembersReached;
  }

  get offerImpressions() {
    return this.offerData.impressions;
  }

  get rules() {
    return this.offerData.rules;
  }

  get isBirthdayOffers() {
    return this.offerData.type === SpecialOfferTypeEnum.BIRTHDAY;
  }

  get isHappyHour() {
    return this.offerData.type === SpecialOfferTypeEnum.HAPPY_HOUR;
  }

  get coinsLabel() {
    const coinLimit = this.rules.filter(
      (item: any) => item.name === EOfferRulesName.LIMIT_RULE
    )[0];

    const BIRTHDAY_OFFER_LIMIT_PER_PERSON = 1;
    if (this.isBirthdayOffers) {
      return this.$t(`${this.tPrefixForm}.coinRule.overview`, {
        coinLimit: BIRTHDAY_OFFER_LIMIT_PER_PERSON,
        coin: this.$tc(
          'common.pluralize.offer',
          BIRTHDAY_OFFER_LIMIT_PER_PERSON
        )
      });
    }

    if (!coinLimit || !coinLimit.value)
      return this.$t(`${this.tPrefixForm}.coinRule.overviewEmpty`);

    return this.$t(`${this.tPrefixForm}.coinRule.overview`, {
      coinLimit: coinLimit.value,
      coin: this.$tc('common.pluralize.offer', coinLimit.value)
    });
  }

  get redeemableTimeLabel() {
    const dayRule = this.rules.filter(
      (item: any) => item.name === EOfferRulesName.REDEEMABLE_DAY_RULE
    )[0];

    const hourRule = this.rules.filter(
      (item: any) => item.name === EOfferRulesName.REDEEMABLE_HOUR_RULE
    )[0];

    return getRedeemableString(
      dayRule ? dayRule.value : '',
      hourRule ? hourRule.value : '',
      'The offer is redeemable'
    );
  }

  get showRenewed() {
    const renewed = this.rules.filter(
      (item: any) => item.name === EOfferRulesName.RENEWED_RULE
    )[0];
    const limit = this.rules.filter(
      (item: any) => item.name === EOfferRulesName.LIMIT_RULE
    )[0];
    return renewed && limit;
  }

  get renewedLabel() {
    const renewedLimit = getRenewedValue(
      this.rules.filter(
        (item: any) => item.name === EOfferRulesName.RENEWED_RULE
      )[0].value
    );

    return this.$t(`${this.tPrefixForm}.renewedRule.overview`, {
      period: renewedLimit.periodFormatted,
      time: renewedLimit.time === '1' ? '' : ` ${renewedLimit.time}`
    });
  }

  get customersLabel() {
    const customerLimit = this.rules.filter(
      (item: any) => item.name === EOfferRulesName.SUPPLY_RULE
    )[0];
    if (!customerLimit || !customerLimit.value)
      return this.$t(`${this.tPrefixForm}.customerRule.overviewEmpty`);

    return this.$t(`${this.tPrefixForm}.customerRule.overview`, {
      customerLimit: customerLimit.value,
      customer: this.$tc('common.pluralize.member', customerLimit.value)
    });
  }

  get expirationLabel() {
    if (this.offerData && this.isBirthdayOffers) {
      return this.$t(`${this.tPrefix}.form.expirationRule.overviewBirthday`);
    }

    const expiration = this.offerData.expirationDate;
    if (!expiration)
      return this.$t(`${this.tPrefixForm}.expirationRule.overviewEmpty`);

    return this.$t(`${this.tPrefixForm}.expirationRule.overview`, {
      date: DateUtils.formattedDate({
        date: expiration,
        applyTimezone: true
      })
    });
  }

  get combineLabel() {
    if (this.offerData && this.isBirthdayOffers) {
      return this.$t(`${this.tPrefixDetail}.combineRule.empty`);
    }

    const combine = this.rules.filter(
      (item: any) => item.name === EOfferRulesName.COMBINE_RULE
    )[0];

    if (combine && combine.value === 'true')
      return this.$t(`${this.tPrefixDetail}.combineRule.empty`);

    return this.$t(`${this.tPrefixDetail}.combineRule.overview`);
  }

  get redeemableLabel() {
    if (this.offerData.method === IOfferMethod.INSTORE)
      return this.$t(`${this.tPrefixDetail}.redeemable.instore`);

    if (this.offerData.method === IOfferMethod.ONLINE)
      return this.$t(`${this.tPrefixDetail}.redeemable.online`);

    return this.$t(`${this.tPrefixDetail}.redeemable.both`);
  }

  get transformedRedeemableLabel() {
    if (this.offerData && this.isBirthdayOffers) {
      return `${this.redeemableLabel}. ID card required.`;
    }

    return this.redeemableLabel;
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get businessName() {
    return this.business.name;
  }

  get description() {
    const { businessName } = this;
    const { title } = this.offerData;
    return `${businessName} is offering ${title}. Get yours today on Twism.`;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get restrictionFieldIsActivated() {
    return this.flags.includes(flagKeys.offerRestrictionField);
  }

  get restrictions() {
    const items = String(
      (this.offerData && this.offerData.restrictions) ||
        this.$t(`${this.tPrefix}.form.coinRule.noRestrictions`)
    ).split(';');

    const openInNewTab = true;

    return items.map(text => renderTextWithLinks(text, openInNewTab));
  }

  get statusDisclaimer() {
    const labelMapper: Record<string, string> = {
      expired_offline_delete_location: String(
        this.$t(
          `${
            this.tPrefixDetail
          }.statusDisclaimer.expired_offline_delete_location`
        )
      ),
      expired_offline_online_delete_location: String(
        this.$t(
          `${
            this.tPrefixDetail
          }.statusDisclaimer.expired_offline_online_delete_location`
        )
      ),
      active_online_delete_location: String(
        this.$t(
          `${this.tPrefixDetail}.statusDisclaimer.active_online_delete_location`
        )
      )
    };

    if (!labelMapper[this.offerData.statusDisclaimer]) return '';

    return labelMapper[this.offerData.statusDisclaimer];
  }

  get reports() {
    return [
      {
        title: 'Opened',
        value: this.opened,
        tooltipText: this.$t(`${this.tPrefixDetail}.tooltip.opened`)
      },
      {
        title: 'Saved',
        value: this.saved,
        tooltipText: this.$t(`${this.tPrefixDetail}.tooltip.saved`)
      },
      this.isHappyHour
        ? {
            title: 'Directions Requested',
            value: this.getDirectionsCount,
            tooltipText: this.$t(`${this.tPrefixDetail}.tooltip.getDirections`)
          }
        : {
            title: 'Redeemed',
            value: this.redeemed,
            tooltipText: this.$t(`${this.tPrefixDetail}.tooltip.redeemed`)
          },
      {
        title: 'Shared',
        value: this.shared,
        tooltipText: this.$t(`${this.tPrefixDetail}.tooltip.shared`)
      },
      {
        title: 'Non-member reached',
        value: this.nonMemberReached,
        tooltipText: this.$t(`${this.tPrefixDetail}.tooltip.nonMemberReached`)
      },
      {
        title: 'Offer impressions',
        value: this.offerImpressions,
        tooltipText: this.$t(`${this.tPrefixDetail}.tooltip.offerImpressions`),
        tooltipInteractive: true
      }
    ];
  }

  handleSort(field: string, rest: any) {
    this.sortChanged(field, rest);
  }

  initFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('active', `Active`),
      new CustomSelectOption('inactive', `Inactive`)
    ]);

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `Member status`,
      false,
      true,
      true,
      true
    );
  }

  handleFilterChange(selectedOptions: CustomSelectOption[]) {
    // if (selectedOptions.length) {
    //   this.$analytics({
    //     eventCategory: 'Special Coin Offers menu first page | Filter',
    //     eventAction: 'change',
    //     eventLabel: `Filtered by status: ${selectedOptions
    //       .map(option => option.label)
    //       .join(', ')}`
    //   });
    // }

    this.filterByStatus(selectedOptions);
  }

  bindEvents() {
    eventBus.$on('archiveOffer', this.archiveOffer);
  }

  unbindEvents() {
    eventBus.$off('archiveOffer');
  }

  initHeader() {
    const header = [
      new HeaderList(`Member`, 'name', '10px 10px 10px 32px'),
      new HeaderList(`Rendemption date`, 'redeemedDate'),
      new HeaderList(`Location`, 'locationName'),
      new HeaderList(`Status`, 'status')
    ];
    this.membersData.header = header;
  }

  reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string,
    callback?: (items: any) => void
  ) {
    if (clearList) {
      this.resetPagination();
      this.membersData.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;
    this.$showLoaderWithLocker();
    this.refreshing = true;
    this.service
      .getOfferMembers(this.$route.params.id, {
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: this.query
      })
      .then(response => {
        const { data } = response;
        const { items, links } = data;

        if (refreshCurrent) {
          this.resetPagination();
          // this.endpointPath = `/${links.next}`;
          this.pagination = decodeURIComponent(links.next);
          if (!links.next) this.maxItems = true;
          this.membersData.list = this.addRowsToList(items);
        } else {
          this.membersData.list = this.membersData.list.concat(
            this.addRowsToList(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = decodeURIComponent(links.next);
          if (this.listEmpty) this.listEmpty = !this.membersData.list.length;
        }
        if (callback) callback(items);
      })
      .catch(() => {})
      .finally(() => {
        this.$hideLoader();
        this.refreshing = false;
        this.isLoading = true;
      });
  }

  addRowsToList(offerMembersRow: any[]): any[] {
    let rows: any[] = [];
    offerMembersRow.forEach((row: any) => {
      const lastActivityAt = DateUtils.formattedDate({
        date: row.lastActivityAt,
        applyTimezone: true,
        format: 'MM/DD/YYYY'
      });
      const redemptionDate = DateUtils.formattedDate({
        date: row.redeemedDate,
        format: 'MM/DD/YYYY',
        applyTimezone: true
      });
      rows.push({
        id: row.id,
        customer: {
          name: `${row.name}${row.lastname ? ` ${row.lastname}` : ''}`
        },
        date: lastActivityAt,
        status: row.status,
        redemptionDate,
        location: row.locationName
      });
    });

    return rows;
  }

  async archiveOffer(isSuccess: boolean) {
    if (!isSuccess) return;

    this.$analytics({
      eventCategory: 'Offer detail page | Archive offer',
      eventAction: 'click',
      eventLabel: 'Archived offer'
    });

    this.$notification('Offer archived');
    this.close();

    eventBus.$emit('reloadOfferList', true, true);
  }

  close() {
    this.$router.push('/special-coins-offers');
  }

  openMemberDetails(memberId: string) {
    this.$router.push(`/performance/customer-center/${memberId}`);
  }

  modalArchiveOffer() {
    const modalProps = {
      offerId: this.offerData.id,
      onArchiveOfferConfirm: (isSuccess: boolean) => {
        this.archiveOffer(isSuccess);
      }
    };

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'archiveOfferModal'
      }),
      modalProps
    );

    this.$analytics({
      eventCategory: 'Offer detail page | Archive button',
      eventAction: 'click',
      eventLabel: 'Clicked on the "Archive offer" button'
    });
  }

  getTagItem(item: any) {
    return (
      SpecialOfferTags.filter(
        element => element.specialType === item.specialType
      )[0] || {}
    );
  }

  async tooltip(toClose?: boolean) {
    if (toClose) {
      this.activeTooltip = false;
      return;
    }
    const shareData = {
      title: this.offerData.title,
      text: this.description,
      url: this.offerData.branchLink
    };

    if ((navigator as any).share) {
      await (navigator as any).share(shareData);
    } else {
      this.activeTooltip = !this.activeTooltip;
    }
  }

  getRelationByMaxRedeemed(row: any, nameParam: string) {
    const rule = row.rules.filter(
      (item: any) => item.name === EOfferRulesName.SUPPLY_RULE
    );
    if (rule.length) return `${row[nameParam]}/${rule[0].value}`;

    return `${row[nameParam]}`;
  }

  handleEndUpload(data: { success: boolean }) {
    this.uploadImageLoading = false;

    if (!data.success) return;

    this.$notification('Offer image updated successfully');
  }

  beforeDestroy() {
    this.unbindEvents();
  }

  async getPageData() {
    this.$showLoaderWithLocker();

    try {
      const { data } = await this.service.getOfferById(this.$route.params.id);

      this.formData.image.imageUrl = data.image
        ? data.image.publicPath.large
        : '';
      this.offerData = {
        ...data,
        ...(data.status === 'expired' &&
          data.metadata &&
          data.metadata.removedLocation && {
            locations: data.metadata.removedLocation
          })
      };
    } finally {
      this.$hideLoader();
    }
  }

  async created() {
    this.getPageData();
    this.bindEvents();
  }
}
